function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "29",
  height: "29",
  viewBox: "0 0 29 29",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M14.512.25l3.746 4.272 5.616-.865.123 5.681 4.858 2.947-3.557 4.431 1.827 5.38-5.573 1.108-2.059 5.296-4.981-2.733L9.531 28.5l-2.059-5.296-5.573-1.108 1.827-5.38-3.557-4.43 4.858-2.948.123-5.68 5.616.864L14.512.25z",
  fill: "#6B1BE3"
})));